import { clsx } from 'clsx';

import { ReactElement } from 'react';

import { PrismicRichText } from '@prismicio/react';
import { PrismicNextImage } from '@prismic/components/PrismicNextImage';

import { generateKey } from '@utils/core';

import { IProps } from './types';
import * as S from './styles';

export function SliceBlogContentTextPhoto({
  slice: { fields },
}: IProps): ReactElement {
  const fieldsMaybe = fields && fields[0];
  const reverseMaybe =
    fieldsMaybe &&
    fieldsMaybe.__typename &&
    fieldsMaybe.__typename === 'Blog_postBodyContent_photo_text_30_60Fields';

  const renderFields = fieldsMaybe
    ? [
        <S.Paragraph
          className={clsx({
            'blog-text-photo__paragraph': true,
            'empty-width': fieldsMaybe && !fieldsMaybe.content_text,
            'full-width': fieldsMaybe && !fieldsMaybe.content_photo,
            reversed: reverseMaybe,
          })}
          key={generateKey(
            fieldsMaybe.content_text.slice(0, 9),
            'blog-text-photo__paragraph'
          )}
        >
          {fieldsMaybe.content_text && (
            <PrismicRichText field={fieldsMaybe.content_text} />
          )}
        </S.Paragraph>,
        <S.Photo
          className={clsx({
            'blog-text-photo__photo': true,
            'empty-width': fieldsMaybe && !fieldsMaybe.content_photo,
            'full-width': fieldsMaybe && !fieldsMaybe.content_text,
            reversed: reverseMaybe,
          })}
          key={generateKey(
            fieldsMaybe.content_text.slice(0, 9),
            'blog-text-photo__photo'
          )}
        >
          {fieldsMaybe.content_photo && (
            <div>
              {fieldsMaybe.photo_link ? (
                <a
                  href={fieldsMaybe.photo_link}
                  target="_blank"
                  rel="noreferrer"
                >
                  <PrismicNextImage
                    field={fieldsMaybe.content_photo}
                    style={{ maxWidth: '100%', height: '100%' }}
                  />
                </a>
              ) : (
                <PrismicNextImage
                  field={fieldsMaybe.content_photo}
                  style={{ maxWidth: '100%', height: '100%' }}
                />
              )}
            </div>
          )}
        </S.Photo>,
      ]
    : [];

  const renderContent = fieldsMaybe ? (
    <S.Wrapper className="slice-item blog-text-photo">
      {reverseMaybe ? renderFields.reverse() : renderFields}
    </S.Wrapper>
  ) : null;

  return renderContent;
}

SliceBlogContentTextPhoto.componentName = 'blog-content-text-photo';
